module.exports = __webpack_public_path__ + "img/usd-circle.29e69569.svg";